const stateKeys = ['changed-service-partner']

export const actions = {
  clearStorage() {
    for (let i = 0; i < stateKeys.length; i++) {
      this.$storage.removeUniversal(stateKeys[i])
    }
  },
  get() {
    return this.$storage.getUniversal('changed-service-partner')
  },
  set(_, servicePartner) {
    this.$storage.setUniversal('changed-service-partner', servicePartner)
  }
}
